import { render, staticRenderFns } from "./McrHeader.vue?vue&type=template&id=b82e08d2"
import script from "./McrHeader.vue?vue&type=script&lang=js"
export * from "./McrHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports